/**
 * StepsBlock — "How It Works" numbered steps display
 *
 * When steps include a `value` field (e.g. "+200 PTS"), renders in
 * "earning rules" mode with right-aligned value badges.
 */
import React from "react";
import { SurfaceStepsConfigResponse } from "@/hooks/hub/useGetHub";
import "./StepsBlock.scss";

interface StepsBlockProps {
    config?: SurfaceStepsConfigResponse;
    sectionTitle?: string;
}

export const StepsBlock = ({ config, sectionTitle }: StepsBlockProps) => {
    if (!config?.steps?.length) return null;

    const layout = config.layout || "horizontal";
    const hasValues = config.steps.some(s => s.value);

    return (
        <div className={`steps-block steps-block--${layout} ${hasValues ? "steps-block--has-values" : ""}`}>
            {sectionTitle && <h3 className="steps-block__title">{sectionTitle}</h3>}
            <div className={`steps-block__list steps-block__list--${layout}`}>
                {config.steps.map((step, index) =>
                    <React.Fragment key={step._id || index}>
                        <div className={`steps-block__step ${hasValues ? "steps-block__step--rule" : ""}`}>
                            <div
                                className="steps-block__number"
                                style={config.accentColor ? { backgroundColor: config.accentColor } : undefined}
                            >
                                {step.iconType === "icon" && step.iconName
                                    ? <span className="steps-block__icon">{step.iconName}</span>
                                    : step.iconType === "image" && step.imageUrl
                                        ? <img src={step.imageUrl} alt={step.title} className="steps-block__step-image" />
                                        : <span>{index + 1}</span>
                                }
                            </div>
                            <div className="steps-block__step-content">
                                <h4 className="steps-block__step-title">{step.title}</h4>
                                <p className="steps-block__step-desc">{step.description}</p>
                            </div>
                            {step.value &&
                                <span className="steps-block__step-value">{step.value}</span>
                            }
                        </div>
                        {config.connectorStyle !== "none" && index < config.steps.length - 1 && !hasValues &&
                            <div className={`steps-block__connector steps-block__connector--${config.connectorStyle || "line"}`} />
                        }
                    </React.Fragment>)}
            </div>
        </div>
    );
};
